import { TextFormatTransformer } from '@lexical/markdown';

// standard markdown does not support underlined text; create a custom transformer for underlined text with the format "__text__"
export const UNDERLINE_TRANSFORMER: TextFormatTransformer = {
  format: ['underline'],
  tag: '__',
  type: 'text-format',
  intraword: false,
};
